import React, { useRef, useState } from 'react';
import { Carousel } from 'primereact/carousel';
import { Button } from 'primereact/button';
import { Galleria } from 'primereact/galleria';
import FileService from '../service/FileService';
import { FileUpload } from 'primereact/fileupload';
import { useTranslation } from 'react-i18next';
import Constants from '../constants/Constants';
import { Dialog } from 'primereact/dialog';
import { Exhibition } from '../pages/exhibition/Exhibition';
import { useNavigate } from 'react-router-dom';
import FavoriteService from '../service/FavoriteService';
import { Toast } from 'reactstrap';
import AuthService from '../security/AuthService';
import EventBus from "../common/EventBus";

const CustomSearchItemDetail = (props) => {
    const { t } = useTranslation();


    const navigate = useNavigate();
    const [displayLoadingDialog, setDisplayLoadingDialog] = useState(false);


    console.log("CustomSearchItemDetail", props)

    const [activeIndex, setActiveIndex] = useState(0);
    const [displayExhibitDialog, setDisplayExhibitDialog] = useState(false);

    const galleriaRef = useRef(null);
    const [showInfo, setShowInfo] = useState(false);


    const responsiveOptions = [
        {
            breakpoint: '1024px',
            numVisible: 5
        },
        {
            breakpoint: '768px',
            numVisible: 3
        },
        {
            breakpoint: '560px',
            numVisible: 1
        }
    ];

    const onAddFavorite = (entityName, artwork) => {

        console.log("onAddFavorite");
        setDisplayLoadingDialog(true);

        let userId = AuthService.getUserId();

        //let rowId = exhibitId;
        //if (Constants.entityNames.artwork === entityName) {
        let rowId = artwork?.fileUpload?.id
        //}

        let apiParams = { userId, entityName, rowId }

        console.log("onAddFavorite", apiParams);

        FavoriteService.add(apiParams).then(
            (response) => {

                console.log("onAddFavorite", response);

                if (response?.data?.error) {
                    setDisplayLoadingDialog(false);

                    let _detail = response.data.error?.innerExceptionMessage;
                    if (t(_detail)) {
                        _detail = t(_detail);
                    }


                    props.toast.current.show({ severity: 'error', summary: t('global_text_errorsummary'), detail: _detail, life: 10000 });
                } else {
                    console.log("onSave", response?.data?.data?.id);
                    //if (Constants.entityNames.artwork === entityName) {
                    artwork.favoriteId = response?.data?.data?.id;
                    //} else {
                    //  setFavoriteId(response?.data?.data?.id);
                    //}

                    setDisplayLoadingDialog(false);

                    let _detail = t('global_success')

                    props.toast.current.show({ severity: 'success', summary: t('global_text_successsummary'), detail: _detail, life: 3000 });
                }
            },
            (error) => {
                setDisplayLoadingDialog(false);

                const _content =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();

                console.log(_content);

                if (error?.response?.status === 403 || error?.Error?.includes("403")) {
                    EventBus.dispatch("logout", props);

                } else {
                    props.toast.current.show({ severity: 'error', summary: t("global_error") + error?.response?.status, detail: t("global_error_detail"), life: 5000 });
                }
            }
        );


    }


    const onRemoveFavorite = (favoriteId, artwork) => {

        console.log("onRemoveFavorite");
        setDisplayLoadingDialog(true);



        let apiParams = { id: favoriteId }

        console.log("onRemoveFavorite", apiParams);

        FavoriteService.remove(apiParams).then(
            (response) => {

                console.log("onRemoveFavorite", response);

                if (response?.data?.error) {
                    setDisplayLoadingDialog(false);

                    let _detail = response.data.error?.innerExceptionMessage;
                    if (t(_detail)) {
                        _detail = t(_detail);
                    }


                    props.toast.current.show({ severity: 'error', summary: t('global_text_errorsummary'), detail: _detail, life: 10000 });
                } else {
                    artwork.favoriteId = null;

                    console.log("onSave", response);

                    setDisplayLoadingDialog(false);

                    let _detail = t('global_success')

                    props.toast.current.show({ severity: 'success', summary: t('global_text_successsummary'), detail: _detail, life: 3000 });
                }
            },
            (error) => {
                setDisplayLoadingDialog(false);

                const _content =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();

                console.log(_content);

                if (error?.response?.status === 403 || error?.Error?.includes("403")) {
                    EventBus.dispatch("logout", props);

                } else {
                    props.toast.current.show({ severity: 'error', summary: t("global_error") + error?.response?.status, detail: t("global_error_detail"), life: 5000 });
                }
            }
        );


    }



    const itemTemplate = (item) => {
        return (

            <div className="grid align-items-end  justify-content-center w-12" style={{}}>

                <div className='text-center col-12 md:col-7 pr-5 ' >
                    <div className='exhibition-images' style={{
                        backgroundImage: `url(${FileService.inquireFilePath(item.filePath)})`,
                    }}
                    />
                </div>
                <div className="col-12 md:col-5 align-items-start pr-5 " >

                    <div id="content_info_div">
                        <span className="block text-6xl  mb-1" style={{ color: '#F7F7F7' }}>
                            {item.name}
                        </span>
                        <span className="block text-1xl  mb-1 " style={{ color: '#F7F7F7' }}>
                            {item.descr}
                        </span>

                        <div className='  mt-2  ' style={{ color: '#F7F7F7' }}>
                            <Button icon="fa-regular fa-heart" className={item.favoriteId ? "p-button-rounded mr-2 mb-2  " : "p-button-rounded p-button-light mr-2 mb-2"} disabled={!AuthService.isLoggedIn()}
                                onClick={() => {
                                    if (item.favoriteId)
                                        onRemoveFavorite(item.favoriteId, item);
                                    else
                                        onAddFavorite(Constants.entityNames.artwork, item)
                                }}
                            />
                            <Button className="p-button-rounded p-button-light mr-2 mb-2" label={item.ownerName} disabled
                            />
                            <Button className="p-button-rounded p-button-light mr-2 mb-2" label={t("technical_info")}
                                onClick={(e) => {
                                    setShowInfo(true);
                                    //opInfo.current.toggle(e);

                                    console.log("technical_info")
                                }}
                            />

                        </div>

                        {artworkInfoPanel(item)}
                    </div>
                </div>

            </div>

        );
    }

    const artworkInfoPanel = (item) => {
        console.log("artworkInfoPanel", item)
        return (
            <Dialog showCloseIcon closeOnEscape dismissable={false} visible={showInfo}
                onHide={() => setShowInfo(false)} className={'artinfo-dialog'} headerClassName='artinfo-dialog-header'
                headerStyle={{ alignSelf: 'flex-end' }}
                contentClassName='artinfo-dialog-content'
            >
                <div className="grid align-items-end  justify-content-center " >


                    <div className='text-center col-12 md:col-7 pr-5 ' >
                    </div>
                    <div className="col-12 md:col-5 align-items-start pr-8" >

                        <div>
                            <span className="block text-6xl  mb-1" style={{ color: '#000000' }}>
                                {item.name}
                            </span>
                            <span className="block text-1xl  mb-1 " style={{ color: '#000000' }}>
                                {item.descr}
                            </span>

                            <div className='  mt-2  ' style={{ color: '#000000' }}>
                                <Button icon="fa-regular fa-heart" className={item.favoriteId ? "p-button-rounded mr-2 mb-2  " : "p-button-rounded p-button-light mr-2 mb-2"} disabled
                                />
                                <Button className="p-button-rounded p-button-light mr-2 mb-2" label={item.ownerName} disabled
                                />
                                <Button className="p-button-rounded p-button-dark mr-2 mb-2" label={t("technical_info")} disabled
                                />
                            </div>
                            <div className="col-12 md:col-12 flex justify-content-between align-items-start text-left " >
                                <div className="register-content w-12 " >
                                    <div className='flex justify-content-between w-12 align-items-center flex-column p-3' style={{ minHeight: 320 }} >
                                        <div className='grid w-12'>
                                            {item.artYear &&
                                                <div className="col-12 md:col-6" style={{
                                                    wordWrap: 'break-word',
                                                    paddingBottom: 5,
                                                }}>
                                                    {t("global_artwork_createdate") + ": " + item.artYear}
                                                </div>
                                            }
                                            {item.artType &&
                                                <div className="col-12 md:col-6" style={{
                                                    wordWrap: 'break-word',
                                                    paddingBottom: 5,
                                                }}>
                                                    {t("global_artwork_" + item.artType)}
                                                </div>
                                            }
                                            {item.artWidth && item.artHeight &&
                                                <div className="col-12 md:col-6" style={{
                                                    wordWrap: 'break-word',
                                                    paddingBottom: 5,
                                                }}>
                                                    {t("global_artwork_measure") + ": " + item.artWidth}x{item.artHeight}  {t("global_artwork_" + item.measureUnit)}
                                                </div>
                                            }
                                            {item.material &&
                                                <div className="col-12 md:col-6" style={{
                                                    wordWrap: 'break-word',
                                                    paddingBottom: 5,
                                                }}>
                                                    {t("global_artwork_material") + ": " + item.material}
                                                </div>
                                            }
                                        </div>
                                        <div className='flex justify-content-between w-12 align-items-center flex-row'

                                        ></div>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>

                </div>


            </Dialog >

        )


    }

    const thumbnailTemplate = (item) => {
        return <img src={FileService.inquireFilePath(item.file)} alt={item.name} style={{ display: 'block' }} onError={(e) => e.target.src = `/assets/layout/images/error_image.png`} />;
    }

    const selectedArtworks = (index) => {
        setActiveIndex(index);
        galleriaRef.current.show()
    }
    const renderItemDetail = () => {
        return (
            <div className="grid" >
                {
                    props.data && props.data.map((param, index) => {


                        let imgEl =
                            <div className='art-images' style={{
                                backgroundImage: `url(${FileService.inquireFilePath(param.filePath?param.filePath:param.profileImage)})`,
                            }}
                                onClick={
                                    () => {
                                            if (param.type == Constants.entityNames.exhibition)
                                                navigate("/exhibition/view/" + param.id);
                                            else if (param.type == Constants.entityNames.artist)
                                                navigate("/profile/" + param.id+"/"+param.type);
                                            else if (param.type == Constants.entityNames.company)
                                                navigate("/profile/" + param.id+"/"+param.type);
                                            else if (param.type == Constants.entityNames.artwork)
                                                selectedArtworks(index);
    
                                        

                                    }
                                } >
                               
                            </div>

                        return (
                            <div className='m-2 mb-6' key={index}>
                                <div className='text-center' style={{ borderRadius: 20, width: 275, height: 225 }}>

                                    {imgEl}
                                </div>
                                <div className='text-2xl  font-400-regular pt-3 ' style={{
                                    ...props.labelStyle
                                }}>
                                    {param.orderName}
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        )
    }

    return (
        <div >
            <Dialog visible={displayLoadingDialog} breakpoints={{ '960px': '75vw' }} closable={false} className='p-dialog-load' header={<></>} >
                <div>
                    <img src="/assets/layout/images/page-loader.gif" alt='Loading...' width="125px" height="125px">
                    </img>
                </div>
            </Dialog>
            <Galleria ref={galleriaRef} value={props.data} responsiveOptions={responsiveOptions} numVisible={7} style={{ width: '60%' }}
                activeIndex={activeIndex} onItemChange={(e) => setActiveIndex(e.index)}
                circular fullScreen showItemNavigators={false} showThumbnails={false} item={itemTemplate} thumbnail={thumbnailTemplate} />

            <div className="grid" >
                {
                    renderItemDetail()
                }
          
               
            </div>

        </div>
    );
};

export default CustomSearchItemDetail;
